import styled, { css } from 'styled-components';
import breakpoint, { map } from 'styled-components-breakpoint';


export const HeaderText = styled.h1`
    font-size: 3.5rem;
    font-family: Lato;
    font-weight: 400;
    color: #fff;
    -webkit-box-decoration-break: clone;
    box-decoration-break: clone;

    span{
        background-image: linear-gradient(to right bottom,#606c88, #3f4c6b);
        padding: 0.5rem 2rem;
        box-shadow: 0 1.5rem 4rem rgba(0, 0, 0, 0.5);
    }
   

`